// @flow

import DataLayerEvent from '../GA4/DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class SetInsiderList extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return Array.isArray(this.data.items);
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    super.dispatch();
    this.push({
      event: EventNames.SET_INSIDER_LIST,
      insider: {
        listing: {
          items: this.data.items
        }
      }
    });
  }
}
